import { Box, Divider, List } from "@chakra-ui/react"
import React, { useEffect, useRef } from "react"
import { useInViewport } from "react-in-viewport"
import { WorkShiftFragment } from "../../graphql"
import { WorkShiftListItem } from "./WorkShiftListItem"

export type WorkShiftsListProps = {
	workShifts: WorkShiftFragment[]
	loadMore: () => void
}

export const WorkShiftsList: React.FC<WorkShiftsListProps> = ({ workShifts, loadMore }) => {
	const ref = useRef()

	const { inViewport } = useInViewport(ref as any, { threshold: 0.25 })

	useEffect(() => {
		if (inViewport) {
			loadMore()
		}
	}, [inViewport, loadMore])

	return (
		<List spacing={2}>
			{workShifts.map((workShift) => (
				<>
					<WorkShiftListItem key={workShift._id} workShift={workShift} />
					<Divider />
				</>
			))}
			<Box w="full" h="2" ref={ref as any} />
		</List>
	)
}
